module.exports = __webpack_public_path__ + "img/delete.679b6c8d.png";